import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7bbc5612 = () => interopDefault(import('../pages/solepro/Home.vue' /* webpackChunkName: "" */))
const _4656c73e = () => interopDefault(import('../layouts/error.vue' /* webpackChunkName: "" */))
const _80935084 = () => interopDefault(import('../pages/solepro/MyAccount.vue' /* webpackChunkName: "" */))
const _ac50eeaa = () => interopDefault(import('../modules/checkout/pages/Cart.vue' /* webpackChunkName: "" */))
const _cdca585a = () => interopDefault(import('../pages/solepro/Cart.vue' /* webpackChunkName: "" */))
const _e503b35e = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _27a262c6 = () => interopDefault(import('../modules/checkout/pages/Checkout/Billing.vue' /* webpackChunkName: "" */))
const _ea43beb0 = () => interopDefault(import('../modules/checkout/pages/Checkout/Payment.vue' /* webpackChunkName: "" */))
const _4d358908 = () => interopDefault(import('../modules/checkout/pages/Checkout/Shipping.vue' /* webpackChunkName: "" */))
const _7a19f1ba = () => interopDefault(import('../modules/checkout/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _90e710f8 = () => interopDefault(import('../modules/checkout/pages/Checkout/UserAccount.vue' /* webpackChunkName: "" */))
const _6feb273d = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _0545df92 = () => interopDefault(import('../pages/solepro/Hub.vue' /* webpackChunkName: "" */))
const _0dbf6ac9 = () => interopDefault(import('../pages/solepro/Librerie.vue' /* webpackChunkName: "" */))
const _2b770807 = () => interopDefault(import('../pages/Maintenance.vue' /* webpackChunkName: "pages/Maintenance" */))
const _178b3917 = () => interopDefault(import('../pages/solepro/Newsletter/Form.vue' /* webpackChunkName: "" */))
const _478a714b = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _812f9bb4 = () => interopDefault(import('../pages/Product/index.vue' /* webpackChunkName: "pages/Product/index" */))
const _269a09b0 = () => interopDefault(import('../pages/solepro/Newsletter/ThankYou.vue' /* webpackChunkName: "" */))
const _d85c6436 = () => interopDefault(import('../pages/solepro/Error.vue' /* webpackChunkName: "pages/solepro/Error" */))
const _5c091878 = () => interopDefault(import('../pages/solepro/HotTopicPage.vue' /* webpackChunkName: "pages/solepro/HotTopicPage" */))
const _d4764646 = () => interopDefault(import('../pages/solepro/HotTopicsPage.vue' /* webpackChunkName: "pages/solepro/HotTopicsPage" */))
const _5d291f9b = () => interopDefault(import('../pages/solepro/Search.vue' /* webpackChunkName: "pages/solepro/Search" */))
const _44a38858 = () => interopDefault(import('../components/AddToCart.vue' /* webpackChunkName: "" */))
const _69b978e1 = () => interopDefault(import('../pages/Product/_slug/index.vue' /* webpackChunkName: "pages/Product/_slug/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/24orepro",
    component: _7bbc5612,
    name: "home___24orepro"
  }, {
    path: "/24orepro/404",
    component: _4656c73e,
    props: {"error":{"statusCode":404,"message":"Pagina non trovata"}},
    name: "not-found___24orepro"
  }, {
    path: "/24orepro/area-privata",
    component: _80935084,
    name: "my-account___24orepro"
  }, {
    path: "/24orepro/cart",
    component: _ac50eeaa,
    name: "cart___24orepro"
  }, {
    path: "/24orepro/cart.html",
    component: _cdca585a,
    name: "solepro-cart___24orepro"
  }, {
    path: "/24orepro/checkout",
    component: _e503b35e,
    name: "checkout___24orepro",
    children: [{
      path: "billing",
      component: _27a262c6,
      name: "billing___24orepro"
    }, {
      path: "payment",
      component: _ea43beb0,
      name: "payment___24orepro"
    }, {
      path: "shipping",
      component: _4d358908,
      name: "shipping___24orepro"
    }, {
      path: "thank-you",
      component: _7a19f1ba,
      name: "thank-you___24orepro"
    }, {
      path: "user-account",
      component: _90e710f8,
      name: "user-account___24orepro"
    }]
  }, {
    path: "/24orepro/Cms",
    component: _6feb273d,
    name: "Cms___24orepro"
  }, {
    path: "/24orepro/hub.html",
    component: _0545df92,
    name: "hub___24orepro"
  }, {
    path: "/24orepro/librerie.html",
    component: _0dbf6ac9,
    name: "librerie___24orepro"
  }, {
    path: "/24orepro/Maintenance",
    component: _2b770807,
    name: "Maintenance___24orepro"
  }, {
    path: "/24orepro/newsletter.html",
    component: _178b3917,
    name: "newsletter-form___24orepro"
  }, {
    path: "/24orepro/Page",
    component: _478a714b,
    name: "Page___24orepro"
  }, {
    path: "/24orepro/Product",
    component: _812f9bb4,
    name: "Product___24orepro"
  }, {
    path: "/24orepro/thank-you.html",
    component: _269a09b0,
    name: "newsletter-typ___24orepro"
  }, {
    path: "/24orepro/solepro/Cart",
    component: _cdca585a,
    name: "solepro-Cart___24orepro"
  }, {
    path: "/24orepro/solepro/Error",
    component: _d85c6436,
    name: "solepro-Error___24orepro"
  }, {
    path: "/24orepro/solepro/Home",
    component: _7bbc5612,
    name: "solepro-Home___24orepro"
  }, {
    path: "/24orepro/solepro/HotTopicPage",
    component: _5c091878,
    name: "solepro-HotTopicPage___24orepro"
  }, {
    path: "/24orepro/solepro/HotTopicsPage",
    component: _d4764646,
    name: "solepro-HotTopicsPage___24orepro"
  }, {
    path: "/24orepro/solepro/Hub",
    component: _0545df92,
    name: "solepro-Hub___24orepro"
  }, {
    path: "/24orepro/solepro/Librerie",
    component: _0dbf6ac9,
    name: "solepro-Librerie___24orepro"
  }, {
    path: "/24orepro/solepro/MyAccount",
    component: _80935084,
    name: "solepro-MyAccount___24orepro"
  }, {
    path: "/24orepro/solepro/Search",
    component: _5d291f9b,
    name: "solepro-Search___24orepro"
  }, {
    path: "/24orepro/vsf/addToCart",
    component: _44a38858,
    props: (route) => {
      const skus = route.query.sku.split(',');
      const modulesSkus = { [skus[0]]: route.query.moduli ? route.query.moduli.split(',') : null }; // this is used only for one product at a time by design, we cannot differ this kind of qs because of the retrocompatibility
      const tipoAbbonamento = {};
      skus.forEach((sku) => {tipoAbbonamento[sku] = route.query.tipoAbbonamento;});
      const tipoConsegna = {};
      skus.forEach((sku) => {tipoConsegna[sku] = route.query.tipoConsegna;});
      return {
        fromRoute: true,
        skus,
        getProductBefore: true,
        modulesSkus,
        tipoAbbonamento,
        tipoConsegna,
        utmCampaign: route.query.utm_campaign
      };
    },
    name: "addToCart___24orepro"
  }, {
    path: "/24orepro/solepro/Newsletter/Form",
    component: _178b3917,
    name: "solepro-Newsletter-Form___24orepro"
  }, {
    path: "/24orepro/solepro/Newsletter/ThankYou",
    component: _269a09b0,
    name: "solepro-Newsletter-ThankYou___24orepro"
  }, {
    path: "/24orepro/Product/:slug",
    component: _69b978e1,
    name: "Product-slug___24orepro"
  }, {
    path: "/24orepro/search/:term?",
    component: _5d291f9b,
    props: (route) => ({
      term: route.params.term ? route.params.term : '',
      isSearch: true
    }),
    name: "search___24orepro"
  }, {
    path: "/24orepro/:slug+",
    component: _478a714b,
    name: "page___24orepro"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
